import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log technical details to console for developers
        console.error("ErrorBoundary caught an error:", error, errorInfo);
    }

    handleReset = () => {
        this.setState({ hasError: false });
        // Optionally reload the page to clear any stuck state
        // window.location.reload(); 
    };

    render() {
        if (this.state.hasError) {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '50vh',
                        p: 3
                    }}
                >
                    <Paper
                        elevation={3}
                        sx={{
                            p: 4,
                            textAlign: 'center',
                            maxWidth: '600px',
                            width: '100%'
                        }}
                    >
                        <Typography variant="h5" component="h2" gutterBottom color="error">
                            Something went wrong
                        </Typography>
                        <Typography variant="body1" color="textSecondary" paragraph>
                            We encountered an unexpected problem while loading this content.
                            Please try refreshing the page or try again later.
                        </Typography>
                        
                        {/* 
                           Technical error details are strictly suppressed from the UI 
                           as per requirements, but logged to console above.
                        */}

                        <Button variant="contained" color="primary" onClick={this.handleReset}>
                            Try Again
                        </Button>
                    </Paper>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
